import React from "react";
import { Line } from "react-chartjs-2";
import { Chart, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend } from "chart.js";
import { generateColors } from "../../utils/helperFunctions";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

Chart.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend);

const LineGraph = ({ items, intervals }) => {
  const { t } = useTranslation();

  const categories = [...new Set(items.map((item) => item.category || "Unknown"))];
  const colores = generateColors(categories.length);
  const data = {
    labels: intervals.map(({ start, end }) => {
      if (start.toDateString() === end.toDateString()) {
        return start.toLocaleDateString("en-US", { month: "short", day: "numeric" });
      }
      return `${start.toLocaleDateString("en-US", { month: "short", day: "numeric" })} - ${end.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      })}`;
    }),
    datasets: categories.map((category, index) => {
      const fieldValue = category;
      const labelKey = `EditableModal.selectValues.${fieldValue}`;
      const translatedLabel = i18n.exists(labelKey) ? t(labelKey) : fieldValue;
      return {
        label: translatedLabel,
        data: intervals.map(({ start, end }) => {
          const startStr = start.toISOString().split("T")[0];
          const endStr = end.toISOString().split("T")[0];
          return items
            .filter((item) => item.purchasedDate >= startStr && item.purchasedDate <= endStr && item.category === category)
            .reduce((sum, item) => sum + Number(item.total || 0), 0);
        }),
        borderColor: colores[index],
        tension: 0.1,
      };
    }),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: $${context.parsed.y.toFixed(2)}`,
        },
      },
    },
    scales: {
      x: { title: { display: true, text: "Date" } },
      y: { title: { display: true, text: "Amount ($)" }, beginAtZero: true },
    },
  };

  return (
    <div style={{ height: "400px" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineGraph;
